import React from 'react';
import Skeleton from 'react-loading-skeleton';

export default function Skel({ loading, children, ...props }) {
  return loading ? <Skeleton {...props} /> : children || null;
}
